import { render } from "./SpecializedDiagnosis.vue?vue&type=template&id=5fb70025&scoped=true"
import script from "./SpecializedDiagnosis.vue?vue&type=script&lang=js"
export * from "./SpecializedDiagnosis.vue?vue&type=script&lang=js"

import "./SpecializedDiagnosis.vue?vue&type=style&index=0&id=5fb70025&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@5.105.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb70025"]])

export default __exports__